import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import InfoIcon from "../../images/info-icon.svg";

const MapComponent = ({
  assignedStops,
  mmiSignKey,
  sourceValue,
  destinationValue,
}) => {
  const mapRef = useRef(null);
  const markersRef = useRef([]);
  const [isMapLoaded, setIsMapLoaded] = useState(false);

  const getMarkersFromAssignedStops = () => {
    return assignedStops.map((item) => ({
      type: "Feature",
      properties: {
        htmlPopup: `${item.name || item.place_name}, ${item.address || item.place_address}`,
      },
      geometry: {
        type: "Point",
        coordinates: [item.lat || item.latitude, item.long || item.longitude ],
      },
      isHighlight: item.isHighlight,
    }));
  };

  const clearMarkers = () => {
    markersRef.current.forEach(marker => marker.remove());
    markersRef.current = [];
  };

  const addMarkers = (map) => {
    const mappls = window.mappls;
    const markerData = getMarkersFromAssignedStops();
    markerData.forEach(data => {
      const marker = new mappls.Marker({
        map,
        position: data.geometry.coordinates,
        icon_url: data.isHighlight === true ? "https://paytmtravel-images-akamai.paytm.com/icons/pointHighlight.png" : "https://paytmtravel-images-akamai.paytm.com/icons/pointNormal.png",
        popupHtml: `<div>${data.properties.htmlPopup}</div>`,
        popupOptions: {
          offset: { bottom: [0, -20] },
        },
      });
      markersRef.current.push(marker);
    });
  };

  useEffect(() => {
    const initMap1 = () => {
      const mappls = window.mappls;
      const map = new mappls.Map("map", {
        traffic: true,
        geolocation: false,
        clickableIcons: false,
        fullscreenControl: false,
        indoor: false,
        zoomControl: true,
        rotateControl: false,
        zoom: 2,
      });
      mapRef.current = map;
      const direction_option = {
        map: map,
        divWidth: "350px",
        isDraggable: false,
        isInput: false,
        start: {
          label: sourceValue.city_name,
          geoposition: `${sourceValue.location.lat},${sourceValue.location.lon}`,
          icon: "https://paytmtravel-images-akamai.paytm.com/icons/origin.png",
        },
        end: {
          label: destinationValue.city_name,
          geoposition: `${destinationValue.location.lat},${destinationValue.location.lon}`,
          "marker-symbol": "https://paytmtravel-images-akamai.paytm.com/icons/origin.png",
        },
        Profile: ["driving"],
        alternative: false,
      };

      const bounds = new mappls.LngLatBounds();
      bounds.extend([sourceValue.location.lon, sourceValue.location.lat]);
      bounds.extend([destinationValue.location.lon, destinationValue.location.lat]);

      map.fitBounds(bounds, {
        padding: { top: 50, bottom: 50, left: 50, right: 50 },
        maxZoom: 10,
      });

      map.on("load", () => {
        setIsMapLoaded(true); // Set map loaded flag

        if (typeof mappls.direction === "function") {
          mappls.direction(direction_option, (data) => {
            if (data.status === "success") {
              console.info("Route displayed successfully");
            } else {
              console.error("Failed to display route:", data);
            }
          });

          const loadIcons = async () => {
            await new Promise((resolve, reject) => {
              map.loadImage(
                "https://paytmtravel-images-akamai.paytm.com/icons/pointHighlight.png",
                (error, image) => {
                  if (error) reject(error);
                  if (!map.hasImage("pointHighlight")) {
                    map.addImage("pointHighlight", image);
                  }
                  resolve();
                }
              );
            });

            await new Promise((resolve, reject) => {
              map.loadImage(
                "https://paytmtravel-images-akamai.paytm.com/icons/pointNormal.png",
                (error, image) => {
                  if (error) reject(error);
                  if (!map.hasImage("pointNormal")) {
                    map.addImage("pointNormal", image);
                  }
                  resolve();
                }
              );
            });
          };

          loadIcons().catch((error) =>
            console.error("Error loading icons:", error)
          );
        } else {
          console.error("mappls.direction is not available");
        }
      });
    };

    let key = mmiSignKey;
    key = atob(key);

    const script1 = document.createElement("script");
    script1.src = `https://apis.mappls.com/advancedmaps/api/${key}/map_sdk?layer=vector&v=3.0&callback=initMap1`;
    script1.async = true;
    document.body.appendChild(script1);

    const script2 = document.createElement("script");
    script2.src = `https://apis.mappls.com/advancedmaps/api/${key}/map_sdk_plugins?v=3.0`;
    script2.async = true;
    document.body.appendChild(script2);

    window.initMap1 = initMap1;

    return () => {
      document.body.removeChild(script1);
      document.body.removeChild(script2);
      delete window.initMap1;
    };
  }, []);

  useEffect(() => {
    if (isMapLoaded && mapRef.current) {
      clearMarkers();
      addMarkers(mapRef.current);
    }
  }, [assignedStops, isMapLoaded]);

  return (
    <div>
      <div className="mapDisc">
        {" "}
        <img src={InfoIcon} className="mapInfoIcon" alt="Information" /> The
        displayed route is indicative and for reference only, the actual route
        may differ from this.
      </div>
      <div
        id="map"
        style={{ width: "100%", height: "550px", display: "inline-block" }}
      ></div>
    </div>
  );
};

export default MapComponent;
